import {
  CrudBuilderState,
  didError,
  didSucceed,
  getCreateSlice,
  getDeleteSlice,
  getErrorMessagePermissive,
  getFetchSlice,
  getUpdateSlice,
  hasStarted
} from "seneca-common/utils/apiStates";

type State = CrudBuilderState;

// create
function getCreateState(state: State) {
  return getCreateSlice(state);
}

export function assignmentIsBeingCreated(
  state: State,
  assignmentId: string
): boolean {
  return hasStarted(getCreateState(state), assignmentId);
}

export function assignmentCreateSucceeded(
  state: State,
  assignmentId: string
): boolean {
  return didSucceed(getCreateState(state), assignmentId);
}

export function assignmentCreateErrored(
  state: State,
  assignmentId: string
): boolean {
  return didError(getCreateState(state), assignmentId);
}

export function assignmentCreateErrorMessage(
  state: State,
  assignmentId: string
) {
  return getErrorMessagePermissive(
    getCreateState(state),
    assignmentId
  )?.toString();
}

// update
function getUpdateState(state: State) {
  return getUpdateSlice(state);
}

export function assignmentIsBeingUpdated(
  state: State,
  assignmentId: string
): boolean {
  return hasStarted(getUpdateState(state), assignmentId);
}

export function assignmentUpdateSucceeded(
  state: State,
  assignmentId: string
): boolean {
  return didSucceed(getUpdateState(state), assignmentId);
}

export function assignmentUpdateErrored(
  state: State,
  assignmentId: string
): boolean {
  return didError(getUpdateState(state), assignmentId);
}

export function assignmentUpdateErrorMessage(
  state: State,
  assignmentId: string
) {
  return getErrorMessagePermissive(
    getUpdateState(state),
    assignmentId
  )?.toString();
}

// delete
function getDeleteState(state: State) {
  return getDeleteSlice(state);
}

export function assignmentIsBeingDeleted(
  state: State,
  assignmentId: string
): boolean {
  return hasStarted(getDeleteState(state), assignmentId);
}

export function assignmentDeleteSucceeded(
  state: State,
  assignmentId: string
): boolean {
  return didSucceed(getDeleteState(state), assignmentId);
}

export function assignmentDeleteErrored(
  state: State,
  assignmentId: string
): boolean {
  return didError(getDeleteState(state), assignmentId);
}

// fetch
function getFetchState(state: State) {
  return getFetchSlice(state);
}

export function classAssignmentIsFetching(
  state: State,
  assignmentId: string
): boolean {
  return hasStarted(getFetchState(state), assignmentId);
}

export function classAssignmentFetchSucceeded(
  state: State,
  assignmentId: string
): boolean {
  return didSucceed(getFetchState(state), assignmentId);
}

export function classAssignmentFetchErrored(
  state: State,
  assignmentId: string
): boolean {
  return didError(getFetchState(state), assignmentId);
}

export function classAssignmentFetchFinished(
  state: State,
  assignmentId: string
) {
  return (
    classAssignmentFetchSucceeded(state, assignmentId) ||
    classAssignmentFetchErrored(state, assignmentId)
  );
}

export function classAssignmentNeedsFetching(
  state: State,
  assignmentId: string
) {
  return !(
    classAssignmentFetchSucceeded(state, assignmentId) ||
    classAssignmentIsFetching(state, assignmentId)
  );
}
